// google、facebook第三方登录提示

let language = {

    GOOGLE_BTN_CONNECTION_FAIL_TITLE: "Connection issue with Google service",
    GOOGLE_BTN_CONNECTION_FAIL_CONTENT: "We need to use google service in this page, but it seem that you can not connect to google."

};

export { language }